<template>
    <div id="paperarrive">
        <!-- {{PlugJson}} -->
    </div>
</template>

<script>
export default {
    name:'paperarrive'
}
</script>

<style scoped>

</style>